import Vue from 'vue';
import VueRouter from 'vue-router';
import Detail from '../second.vue'
import Index from '../Index.vue'

Vue.use(VueRouter); 
const routes = [
  {
    path: '/',
    name: 'Home',
    redirect:'/Index',
  },
  {
    path: '/detail',
    name: 'Detail',
    component: Detail,
  },
  {
    path: '/Index',
    name: 'App',
    component: Index,
  }
];

const router = new VueRouter({
  base:'/',
  routes
});
export default router;
